// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"717":"275b7c0e","771":"d6f92e12"}[chunkId] + ".chunk.css";
};